import { supportPhoneDashed, supportPhoneLink } from '@/constants'
import { Icon } from '@/components'
import styles from './AreaPageHeader.module.scss'

export const AreaPageHeader = () => {
  return (
    <header className={styles.header}>
      <img src="/images/logo-full.svg" alt="Логотип HippoParking" className={styles.logo} />
      <a href={supportPhoneLink} className={styles.supportPhone}>
        <Icon name="phone-headset-icon" />
        <span className={styles.supportPhone__number}>{supportPhoneDashed}</span>
      </a>
    </header>
  )
}
